import { commaFormat } from "@p-ban/common/src/utils/NumberUtils"

type Props = {
  name: string
  days: number | null
  amount: number | null
  checked?: boolean
  isRadioMode?: boolean
  disabled?: boolean
  shouldShowDays?: boolean
  children?: React.ReactNode
}

/**
 * コース表示コンポーネント
 * @param name コース名
 * @param days 日数
 * @param amount 金額
 * @param checked チェック状態
 * @param isRadioMode
 * @param disabled
 * @param shouldShowDays 日数表示有無。デフォルトはtrue(実装短納期コースをfalseで表現するために定義)
 * @param children 子要素
 * @constructor
 */
const CourseBox = ({
  name,
  days,
  amount,
  checked = false,
  isRadioMode = false,
  disabled = false,
  shouldShowDays = true,
  children,
}: Props) => {
  const isInactive = disabled || (isRadioMode && !checked)
  const fontWeight = isInactive ? "font-normal" : "font-bold"

  const courseContent = (
    <>
      <span className={`text-charcoal-gray flex-shrink-0 text-xs leading-none tracking-tighter ${fontWeight}`}>
        {name}
      </span>
      <div className="flex">
        {shouldShowDays && (
          <span className={`text-charcoal-gray text-right text-xs ${fontWeight}`}>
            <span className={`text-xs ${fontWeight}`}>{days ?? "-"}</span>
            <span className={`text-xs ${fontWeight}`}>日</span>
          </span>
        )}
        {shouldShowDays ? (
          <span className={`text-charcoal-gray w-[104px] text-right text-xs ${fontWeight}`}>
            {amount ? (
              <>
                <span className={`text-xs ${fontWeight}`}>{commaFormat(amount)}</span>
                <span className={`text-xs ${fontWeight}`}>円+税</span>
              </>
            ) : (
              "見積依頼"
            )}
          </span>
        ) : (
          // 実装コース：実装短納期のケースを想定した表示
          <span className={`text-charcoal-gray w-[126px] text-left text-xs ${fontWeight}`}>見積依頼</span>
        )}
      </div>
    </>
  )

  // 子要素がある場合
  if (children) {
    return (
      <div className="relative">
        <div className="flex h-[26px] items-center justify-between px-[3px] leading-none">{courseContent}</div>
        {children}
      </div>
    )
  }

  // 子要素がない場合（通常のコース）
  return (
    <div className="relative flex h-[26px] items-center justify-between px-[3px] leading-none">{courseContent}</div>
  )
}

export default CourseBox
